/**
 * Bir takip satırını, UYAP dosyaId'sine bağlı olmadan kararlı biçimde tanımlar.
 *
 * dosyaId anahtar olarak kullanılamıyor:
 *  - Excel ile yüklenen takiplerde hiç gelmiyor (GenelIslemFormWizard.parseExcelFile
 *    satırlara yalnızca birimAdi/dosyaNo/birimId yazıyor).
 *  - UYAP'tan gelenlerde ise şifreli ve bayatlıyor (bkz. DosyaBul.dosyaEslestir yorumu:
 *    "Kararlı kimlik ikilisi birimId + dosyaNo'dur").
 *
 * birimId Excel'de çözülemeyebildiği için birimAdi'na düşülür; anahtarı üreten ve
 * tüketen taraflar aynı takip nesnesini okuduğu için bu fallback tutarlıdır.
 */
export function dosyaAnahtari(takip: any): string {
  if (!takip)
    return '';
  const birim = String(takip.birimId || takip.birimAdi || '').trim();
  const dosyaNo = String(takip.dosyaNo || '').trim();
  if (!birim && !dosyaNo)
    return '';
  return birim + '|' + dosyaNo;
}
